import { render, staticRenderFns } from "./maticinfo.vue?vue&type=template&id=4a8b70a0&"
import script from "./maticinfo.vue?vue&type=script&lang=js&"
export * from "./maticinfo.vue?vue&type=script&lang=js&"
import style0 from "./maticinfo.vue?vue&type=style&index=0&id=4a8b70a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports